module.exports = __webpack_public_path__ + "img/icon-image.fc6f5a94.svg";